export default __webpack_public_path__ + "static/media/xls.c00d473c.svg";